"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _constants = require("../../constants");
var _Modal = _interopRequireDefault(require("./Modal"));
var _AutoIntl = _interopRequireDefault(require("../elements/AutoIntl"));
var _AuButton = _interopRequireWildcard(require("../elements/AuButton"));
var _ProcessingButton = _interopRequireDefault(require("../elements/ProcessingButton"));
var _context, _context2, _context3;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "container": "confirmation_dialog-module__container___rglDb",
  "small_container": "confirmation_dialog-module__small_container___JDZif confirmation_dialog-module__container___rglDb",
  "icon": "confirmation_dialog-module__icon___wGQsc",
  "alert": "confirmation_dialog-module__alert___NyhgV confirmation_dialog-module__icon___wGQsc",
  "warning": "confirmation_dialog-module__warning___n07_Y confirmation_dialog-module__icon___wGQsc",
  "success": "confirmation_dialog-module__success___QkfZl confirmation_dialog-module__icon___wGQsc",
  "header": "confirmation_dialog-module__header___fqMHx",
  "close": "confirmation_dialog-module__close___SyG9B",
  "body": "confirmation_dialog-module__body___EjkOS",
  "small_body": "confirmation_dialog-module__small_body___zkpTZ",
  "buttons": "confirmation_dialog-module__buttons___Y4ZKo",
  "cancel": "confirmation_dialog-module__cancel___IVSjh",
  "button": "confirmation_dialog-module__button___lwSOM"
};
class ConfirmationDialog extends _react.default.Component {
  static propTypes = {
    type: T.oneOf(['alert', 'warning', 'success']),
    buttonType: T.oneOf(_AuButton.default.types),
    titleId: T.string,
    titleString: T.string,
    messageId: T.string,
    messageString: T.string,
    confirmDisplayId: T.string,
    cancelDisplayId: T.string,
    className: T.string,
    headerClassName: T.string,
    buttonsClassName: T.string,
    bodyClassName: T.string,
    showCloseIcon: T.bool,
    showCancelButton: T.bool,
    onConfirm: T.func,
    onCancel: T.func,
    size: T.oneOf(['small', 'large'])
  };
  static defaultProps = {
    confirmDisplayId: 'au.dialog.confirm',
    cancelDisplayId: 'au.dialog.cancel',
    showCloseIcon: true,
    showCancelButton: true,
    onConfirm: _constants.NOOP,
    onCancel: _constants.NOOP,
    size: 'large'
  };
  handleOnConfirm = (0, _bind.default)(_context = this.handleOnConfirm).call(_context, this);
  handleOnConfirm(ev) {
    return this.props.onConfirm(ev);
  }
  handleOnCancel = (0, _bind.default)(_context2 = this.handleOnCancel).call(_context2, this);
  handleOnCancel(ev) {
    this.props.onCancel(ev);
  }
  onKeyDown = (0, _bind.default)(_context3 = this.onKeyDown).call(_context3, this);
  onKeyDown(ev) {
    if (ev.key === _constants.ESCAPE_KEY) {
      this.handleOnCancel(ev); // NOTE: not a synthetic event
    }
  }

  componentDidMount() {
    document.addEventListener('keydown', this.onKeyDown, false);
  }
  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown, false);
  }
  render() {
    const {
      type,
      messageId,
      messageString,
      titleId,
      titleString,
      confirmDisplayId,
      cancelDisplayId,
      className,
      headerClassName,
      showCloseIcon,
      showCancelButton,
      bodyClassName,
      buttonsClassName,
      size
    } = this.props;
    const small = size === 'small';
    let {
      buttonType
    } = this.props;
    if (!buttonType) {
      buttonType = type === 'alert' ? _AuButton.BUTTON_TYPE_ALERT : _AuButton.BUTTON_TYPE_PRIMARY;
    }
    return /*#__PURE__*/_react.default.createElement(_Modal.default, null, /*#__PURE__*/_react.default.createElement("div", {
      className: small ? (0, _classnames.default)(styles.small_container, styles[type], className) : (0, _classnames.default)(styles.container, styles[type], className)
    }, showCloseIcon && /*#__PURE__*/_react.default.createElement("div", {
      className: styles.close,
      onClick: this.handleOnCancel
    }), /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      className: (0, _classnames.default)(styles.header, headerClassName),
      displayId: titleId,
      displayString: titleString,
      tag: "div"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: small ? (0, _classnames.default)(styles.body, styles.small_body, bodyClassName) : (0, _classnames.default)(styles.body, bodyClassName)
    }, this.props.children || /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      displayId: messageId,
      displayString: messageString
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.buttons, buttonsClassName)
    }, /*#__PURE__*/_react.default.createElement(_ProcessingButton.default, {
      type: buttonType,
      className: styles.button,
      displayId: confirmDisplayId,
      onClick: this.handleOnConfirm,
      disabled: this.props.confirmBtnDisabled
    }), showCancelButton && /*#__PURE__*/_react.default.createElement(_AuButton.default, {
      type: "plain",
      className: styles.cancel,
      displayId: cancelDisplayId,
      onClick: this.handleOnCancel
    }))));
  }
}
exports.default = ConfirmationDialog;